import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import CommingSoonDetail from "../comming-soon-detail-image";
import { getCarDetailsGalleryPageURL } from "../../../utils/helpers/get-detail-page-url";
import { useHistory } from "react-router-dom";
import { GALLERY_TAB_TYPE, MEDIA_SOURCE } from "../../../constants/app-constants";
// import HeroSliderCdpRevamp from "../hero-slider-cdp-revamp";
import HeroSliderCdpRevamp from "../hero-slider-cdp-revamp";
import VideoCatalogCdpHeroslider from "../video-catalog-cdp-heroslider";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import { VIDEO_CATALOG_AMPLITUDE_EVENTS, VIDEO_CATALOG_GA_EVENTS_DESKTOP } from "../video-gallery-slider/tracking";
import getCarInfo from "../../../utils/helpers/get-car-info";
import { imageTypes } from "../../../utils/helpers/cdn-image-url";

const CarDetailOuterImagesRevamp = ({
    content = {},
    setGsGalleryDataConnect,
    onWishlistClick,
    isWishlisted,
    showWishListIcon,
    isStickyHeaderVisible,
    webCarTour,
    calculatorRef,
    scrollToSection,
    isFetchingOrderDetails,
    isKbbShown,
    handleKbbModal,
    ctaProps,
    step,
    config
}) => {
    const {
        comingSoon,
        mediaSource,
        threeSixtyViewUrl
    } = content || {};
    const updatedConfig = {...config, displayImageType: imageTypes.dealerSubHeaderDesktop};
    const {carImage} = getCarInfo(content, updatedConfig) || {};
    const history = useHistory();

    // is car tour present in content
    const isCarTourPresent = content?.carTourPresent;

    const onClickImageCarTour = (activeTab = "", imageIndex = 0, subActiveTab = "") => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_IMAGE_GALLERY_VIEW, {
            eventLabel: `Section selected ${activeTab}`
        });
        if (mediaSource === MEDIA_SOURCE.helloAR) {
            const params = {
                activeTab: threeSixtyViewUrl ? GALLERY_TAB_TYPE.threeSixtyViewUrl : activeTab,
                subActiveTab,
                isOpen: true,
                selectedImageIndex: imageIndex
            };
            setGsGalleryDataConnect(params);
            const url = getCarDetailsGalleryPageURL({
                content,
                activeTab: params.activeTab,
                subActiveTab: params.subActiveTab,
                selectedImageIndex: params.selectedImageIndex,
                mediaSource
            });
            history.push(url);
        } else {
            const url = getCarDetailsGalleryPageURL({content, activeTab, selectedImageIndex: imageIndex });
            history.push(url);
        }
    };

    const showWebCarTour = getAbExpirementVariant(webCarTour, EXPERIMENT_TYPE.VARIANT_B);

    const ViewComponent =  (showWebCarTour && isCarTourPresent) ? VideoCatalogCdpHeroslider : HeroSliderCdpRevamp;
    const onClickFunction = onClickImageCarTour;

    useEffect(() => {
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_CATALOUGE_VARIANT_ASSIGNED, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.VIDEO_CATALOUGE_VARIANT_ASSIGNED,
            eventLabel: showWebCarTour ? "VARIANT_B" : "VARIANT_A"
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <div styleName={"styles.containerBackground"}>
                {comingSoon && !(Array.isArray(content && content.galleryV2) && content.galleryV2.length > 0) ?
                    <CommingSoonDetail bodyType={content.body || content.bodyType} fullScreenGallery={true} carImage={carImage}/>
                    :
                    <ViewComponent
                        openGalleryPopUp={onClickFunction}
                        onWishlistClick={onWishlistClick}
                        isWishlisted={isWishlisted}
                        showWishListIcon={showWishListIcon}
                        isStickyHeaderVisible={isStickyHeaderVisible}
                        calculatorRef={calculatorRef}
                        scrollToSection={scrollToSection}
                        isFetchingOrderDetails={isFetchingOrderDetails}
                        isKbbShown={isKbbShown}
                        handleKbbModal={handleKbbModal}
                        ctaProps={ctaProps}
                        step={step}
                    />
                }
            </div>
        </div>
    );
};

CarDetailOuterImagesRevamp.propTypes = {
    content: PropTypes.object,
    setGsGalleryDataConnect: PropTypes.func,
    onWishlistClick: PropTypes.func,
    isWishlisted: PropTypes.bool,
    showWishListIcon: PropTypes.bool,
    isStickyHeaderVisible: PropTypes.bool,
    webCarTour: PropTypes.object.isRequired,
    calculatorRef: PropTypes.object,
    scrollToSection: PropTypes.func,
    isFetchingOrderDetails: PropTypes.bool,
    isKbbShown: PropTypes.bool,
    handleKbbModal: PropTypes.func,
    ctaProps: PropTypes.object,
    step: PropTypes.object,
    config: PropTypes.object

};

export default CarDetailOuterImagesRevamp;
